var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeaturedCompainesLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3337 40.3333L3.66699 40.3333",
    stroke: "#004945",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5002 40.3334V23.8334M20.1748 9.16675C20.2077 6.89381 20.3763 5.60519 21.2408 4.74069C22.3147 3.66675 24.0432 3.66675 27.5002 3.66675H31.1668C34.6238 3.66675 36.3523 3.66675 37.4262 4.74069C38.5002 5.81463 38.5002 7.54312 38.5002 11.0001V16.5001",
    stroke: "#004945",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 40.3334V29.3334M5.5 40.3334V23.8334M5.5 16.5001C5.5 13.0431 5.5 11.3146 6.57394 10.2407C7.64788 9.16675 9.37637 9.16675 12.8333 9.16675H20.1667C23.6236 9.16675 25.3521 9.16675 26.4261 10.2407C27.5 11.3146 27.5 13.0431 27.5 16.5001V22.0001",
    stroke: "#004945",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 40.3333V34.8333",
    stroke: "#004945",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 14.6667H22",
    stroke: "#0B847E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11 20.1667H12.8333M22 20.1667H17.4167",
    stroke: "#0B847E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11 25.6667H22",
    stroke: "#0B847E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedCompainesLogo);
export default __webpack_public_path__ + "static/media/FeaturedCompainesLogo.76b2c0578add71e12823fde219cdf1f0.svg";
export { ForwardRef as ReactComponent };